// extracted by mini-css-extract-plugin
export default {"back":"styles_back__gndkS","arrow":"styles_arrow__4+syH"};